import api, { ValidateAxiosError, } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';

interface CreateFuncaoDto {
  id?: number;
  nome: string;
}

interface UpdateFuncaoDto extends Partial<CreateFuncaoDto> {
  id: number;
}

interface ReadFuncaoDto {
  id: number;
  nome: string;
  editadoPor?: { id: number; nome: string };
  editadoEm?: Date;
}

interface FindFuncaoDto {
  skip?: number;
  take?: number;
  id?: number;
  where?: string | null;
  orderBy?: string;
  orderField?: string;
}

const endpoint = Endpoints.FUNCAO;

export async function createFuncao(dto: CreateFuncaoDto) {
  try {
    const response = await api.post(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar a função.');
  }
}

export async function readFuncao(filters: FindFuncaoDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadFuncaoDto[], number]>(endpoint, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar função(s).');
  }
}

export async function updateFuncao(dto: UpdateFuncaoDto) {
  try {
    const response = await api.put(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar a função.');
  }
}

export async function deleteFuncao(id: number) {

  try {
    const response = await api.delete(endpoint + '/' + id)
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao remover a função.');
  }
}

